import { render, staticRenderFns } from "./AiSeo.vue?vue&type=template&id=8801ccb0&scoped=true"
import script from "./AiSeo.vue?vue&type=script&lang=js"
export * from "./AiSeo.vue?vue&type=script&lang=js"
import style0 from "./AiSeo.vue?vue&type=style&index=0&id=8801ccb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8801ccb0",
  null
  
)

export default component.exports